import { render, staticRenderFns } from "./games-general-settings.vue?vue&type=template&id=b119d74c"
import script from "./games-general-settings.vue?vue&type=script&lang=js"
export * from "./games-general-settings.vue?vue&type=script&lang=js"
import style0 from "./games-general-settings.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/games-general-settings.vue
// module id = ch50
// module chunks = 0